import { t } from 'i18next'
import React from 'react'
import { Link } from 'react-router-dom'
import { Action, mk_widget, Widget } from 'widgets-for-react'
import { decodeHTMLEntities, toRelativeUrl } from '../../../helpers'
import { HeaderState, OptionsState } from '../../public_site.main.mod'
import { WordPress } from '../../wordpress/wordpress_api'
import MainNavItems from './nav_items_main'
import { SearchBar } from './searchbar'

export const header: (_: HeaderState, o: OptionsState) => Widget<Action<HeaderState>> = (
  props,
  opts
) =>
  mk_widget({
    run: setState => {
      const getLanguageOptions = () => {
       let languageArray = [{short: 'en',full: 'English'},{short: 'nl',full:'Dutch'}, {short: 'de', full: "German" }];
       try {
         const currentLanguage = window.wp.language;
         if(currentLanguage == "en"){
          languageArray.splice(0,1);
         }else if(currentLanguage == "nl"){
          languageArray.splice(1,1);
         }else if(currentLanguage == "de"){
          languageArray.splice(2,1);
         }
       }catch(error){}
       return languageArray;
      }
      const languageArray = getLanguageOptions();
      return (
        <Header
          className="header"
          onMouseLeave={_ => setState(s => ({...s, hoveredItem: null}))}
        >
          <div className="header__inner grid--gutter container--xl">
            <div className="header__logo">
              <Link to={window.wp.language == 'en' ? "/" : `/${window.wp.language}` }>
                {/* This is the corporate logo */}
                {/* <img className="header__image header__image--mobile" src="/frontend/images/logo.svg" alt="FrieslandCampina logo" />
                <img className="header__image header__image--desktop-up" src="/frontend/images/logo-subtitle.svg" alt="FrieslandCampina logo" /> */}
                {/* This is the temporary 150y logo */}
                <img className="header__image header__image--mobile" src="/frontend/images/logo--mobile.svg" alt="FrieslandCampina 150 year anniversary logo" />
                <img className="header__image header__image--desktop-up" src="/frontend/images/logo--desktop.svg" alt="FrieslandCampina 150 year anniversary logo" />
              </Link>
            </div>
            <nav className="header__nav nav nav--main">
              <MainNavItems
                cssClass="desktop"
                location="main"
                hasActiveState={true}
                hoveredItem={props.hoveredItem}
                onHoverItem={item => setState(s => ({...s, hoveredItem: item}))}
                onUnhoverItem={() => setState(s => ({...s, hoveredItem: null}))}
              />
            </nav>
            <ul className="header__list">
              {/* {(window.wp.language == 'ng') ? <></> : 
              <li className={`header__item typo--4xs language ${props.lang == "open" ? " language--open" : ""}`}>
                <a
                  className="language__switch"
                  onClick={_ => setState(s => ({...s, lang: props.lang == "open" ? "closed" : "open"}))}
                >
                  {t("header.language")}
                  <svg
                    width="18px"
                    height="8px"
                    aria-hidden="true"
                    className={`language__icon${props.lang == "open" ? " language__icon--close" : ""}`}
                  >
                    <use xlinkHref={`#${props.lang == "open" ? "icon--close" : "chevron--down"}`} />
                  </svg>
                </a>
                {props.lang == "open" && (
                    <ul className="language__list">
                      {languageArray.map(avLang => (
                        <li>
                          <a 
                            onClick={(_) => 
                              window.dataLayer.push({
                                event: "event.fccorporate", category: "Language", action: avLang.full, label: window.location.pathname
                              })
                            }
                            href={`/${avLang.short.toLowerCase() != "en" ? avLang.short.toLowerCase() : ""}`}>
                            {avLang.full}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
              </li>
              } */}
              <li className="header__item">
                <button
                  className="header__button search"
                  onClick={_ => {
                    setState(s => ({
                      ...s,
                      showSearchBar: !props.showSearchBar
                    }));
                    !props.showSearchBar
                      ? document.body.classList.add("noscroll")
                      : document.body.classList.remove("noscroll");
                  }}
                >
                  <svg className="search__icon" width="18px" height="16px">
                    <use xlinkHref="#icon--search" />
                  </svg>
                </button>
              </li>
              <li className="header__item">
                <button
                  className="header__toggler toggler"
                  onClick={_ => setState(s => ({...s, menu: props.menu == "open" ? "closed" : "open"}))}
                  aria-controls="a11y-menu"
                  aria-expanded={props.menu == "open" ? true : false}
                >
                  <span className="sr-text">Toggle Menu</span>
                  <span className="toggler__line toggler__line--close" />
                  <span className="toggler__line toggler__line--close" />
                  <span className="toggler__line" />
                </button>
              </li>
            </ul>
            <SearchBar
              show={props.showSearchBar}
              hide={() => {
                setState(s => ({...s, showSearchBar: false}));
              }}
              searchValue={props.searchValue}
              updateSearchValue={newValue => setState(s => ({...s, searchValue: newValue}))}
            />
          </div>
          {props.hoveredItem && props.hoveredItem.child_items && props.hoveredItem.child_items.length > 0 && (
            <div className="header__flyout flyout flyout--open">
              <div className="flyout__wrapper">
                <div className="flyout__inner">
                  <div className="flyout__row">
                    <div className="flyout__column">
                      {props.hoveredItem.title && <h3 className="flyout__title typo--l">{decodeHTMLEntities(props.hoveredItem.title)}</h3>}
                    </div>
                  </div>
                  <div className="flyout__row">
                    <div className="flyout__column flyout__column--cta">
                      {props.hoveredItem.description && <p className="flyout__description typo--2xs">{props.hoveredItem.description}</p>}
                      {props.hoveredItem.button_label && (
                        <Link to={toRelativeUrl(props.hoveredItem.url)} className="button button--secondary">
                          {props.hoveredItem.button_label}
                        </Link>
                      )}
                    </div>
                    <div className="flyout__column flyout__column--menu">
                      <div className="nav nav--submenu">
                        <ul className="nav__list">
                          {props.hoveredItem.child_items.length > 0 ? (
                            <>
                              {props.hoveredItem.child_items.map((menuChild: WordPress.MenuItem) => (
                                <li className="nav__item  typo--2xs" key={`main-child-${menuChild.ID}`}>
                                  <Link to={toRelativeUrl(menuChild.url)} className="nav__link nav__link--sub">
                                    {menuChild.title}
                                  </Link>
                                </li>
                              ))}
                            </>
                          ) : (
                            <></>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Header>
      );
    }
  })

type HeaderComponentState = {
  // sticky: boolean
  // shown: boolean
}

type HeaderComponentProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {

}

class Header extends React.Component<HeaderComponentProps, HeaderComponentState> {
  // private raf: number
  private headerRef: HTMLElement
  // private headerHeight: number = 0
  // private scrollStartTime: number = 0
  // private scrollStartY: number = 0

  constructor(props) {
    super(props)

    this.state = {
      // sticky: false,
      // shown: false
    };

    // this.updateScrollState = this.updateScrollState.bind(this)
    // this.raf = window.requestAnimationFrame(this.updateScrollState)
  }

  componentWillUnmount() {
    // window.cancelAnimationFrame(this.raf)
  }

  updateScrollState(t: number) {
    // this.raf = window.requestAnimationFrame(this.updateScrollState)
    // this.headerHeight = this.headerRef.clientHeight

    // if (window.pageYOffset < (this.headerHeight / 2)) {
    //   this.setState({
    //     ...this.state,
    //     sticky: false,
    //     shown: true
    //   })
    //   return
    // }

    // if (
    //   this.scrollStartTime > 0 &&
    //   t - this.scrollStartTime < 100 &&
    //   this.scrollStartY - window.pageYOffset > 10
    // ) {
    //   this.setState({
    //     ...this.state,
    //     shown: true
    //   })
    //   return
    // } else if (
    //   this.scrollStartY - window.pageYOffset < 0 &&
    //   this.props.mobileMenu != "open"
    // ) {
    //   this.setState({
    //     ...this.state,
    //     shown: false
    //   })
    // }

    // this.scrollStartY = window.pageYOffset
    // this.scrollStartTime = t

    // if (window.pageYOffset > this.headerHeight) {
    //   if (!this.state.sticky) {
    //     this.setState({
    //       ...this.state,
    //       sticky: true
    //     })
    //   }
    // } else {
    //   this.setState({
    //     ...this.state,
    //     sticky: false
    //   })
    // }
  }

  render() {
    return (
      // ${
      //   this.state.sticky ? " header--stucky" : ""
      // }${this.state.shown ? " header--showny" : ""}${
      //   this.props.mobileMenu == "open" ? " header--full-menu" : ""
       // }
        <header ref={ref => (this.headerRef = ref)} {...this.props}></header>
    )
  }
}
